<div class="col-12 bonus" (click)="showBonusFullOffer()">
  <div class="title">*$500 OFF Your First Mobile Phone Order</div>
  <div class="call-to-action"><a role="button" (click)="showBonusFullOffer()">View Offer</a></div>
</div>
<app-bonus-offer-full *ngIf="isShowBonusFullOffer" (onHideBonusFullOffer)="hideBonusFullOffer()"></app-bonus-offer-full>
